<template>
  <div v-frag>
    <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
      <v-dialog
        transition="dialog-bottom-transition"
        persistent
        v-model="viewDialog"
      >
        <CardIeaAppMain :profile="false">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <div class=" text-h6 font-weight-medium">Verificación de datos</div>
          </v-col>
          <v-fade-transition>
            <div v-frag v-if="!validateEmail">
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <VueFakeInput
                  :length="4"
                  :fontSize="40"
                  inputColor="#1565C0"
                  borderColor="#000000"
                  fontColor="#000000"
                  :allowPaste="false"
                  v-model="codeEmail"
                  :code="codeEmail"
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8" align="start">
                <p class="text-start">Hemos enviado un email a <b>{{emailLabel}}</b></p>
                <p
                  @click="panelEmail = !panelEmail"
                  class="black--text text-decoration-underline font-weight-regular"
                  style="cursor:pointer;"
                  v-if="cantidadValidacionEmail < 2"
                >
                  ¿No recibistes el código?
                </p>
                <v-alert
                  outlined
                  type="warning"
                  prominent
                  border="left"
                  v-else
                >
                  ¡UPS! Has llegado al limite de intentos , por favor prueba mas tarde
                </v-alert>
              </v-col>
              
              <v-expand-transition>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-show="panelEmail">
                  <CardIeaApp colorCard="#FFFFFF" title="">
                      <v-row align="center">
                        <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                          <InputCustom :inputProp="inputs[0]" />
                        </v-col>
                      </v-row>         
                  </CardIeaApp>
                </v-col>
              </v-expand-transition>
              <v-expand-transition>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-show="panelEmail">
                    <v-btn
                    @click="restCode(1)"
                    block
                    x-large
                    class="white--text rounded-lg font-weight-regular"
                    depressed
                    color="btnSuccess"
                    :loading="loader"
                    >Modificar</v-btn
                    >
                </v-col>
              </v-expand-transition>       
            </div>
          </v-fade-transition>
          <v-fade-transition>
            <div v-frag v-if="!validateSms">
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <VueFakeInput
                  :length="4"
                  :fontSize="40"
                  inputColor="#1565C0"
                  borderColor="#000000"
                  fontColor="#000000"
                  :allowPaste="false"
                  v-model="codeSms"
                  :code="codeSms"
                />
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8" align="start">
                <p class="text-start">Hemos enviado un sms a  <b>+{{smsLabel}}</b></p>
                <p
                  @click="panelSms = !panelSms"
                  class="black--text text-decoration-underline font-weight-regular"
                  style="cursor:pointer;"
                  v-if="cantidadValidacionSms < 2"
                >
                  ¿No recibistes el código?
                </p>
                <v-alert
                  outlined
                  type="warning"
                  prominent
                  border="left"
                  v-else
                >
                  ¡UPS! Has llegado al limite de intentos , por favor prueba mas tarde
                </v-alert>
              </v-col>

              
                <v-expand-transition>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-show="panelSms">
                  <CardIeaApp colorCard="#FFFFFF" title="">
                      <v-row align="center">
                        <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                          <InputCustom :inputProp="inputs[1]" />
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <InputCustom :inputProp="inputs[2]" />
                        </v-col>
                      </v-row>
                  </CardIeaApp>
                </v-col>
                </v-expand-transition>
                <v-expand-transition>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-show="panelSms">
                    <v-btn
                        @click="restCode(2)"
                        block
                        x-large
                        class="white--text rounded-lg font-weight-regular"
                        depressed
                        color="btnSuccess"
                        :loading="loader"
                        >Modificar</v-btn
                        >
                    </v-col>
                  </v-expand-transition>
            </div>
          </v-fade-transition>
          <br><br><br><br><br><br>
          <v-divider></v-divider>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-btn
              @click="omitirValidacion()"
              block
              x-large
              class="blue--text text-decoration-underline font-weight-regular"
              depressed
              text
              color="#FFFFFF"
              :loading="loader"
              >Omitir</v-btn
              >
          </v-col>
        </CardIeaAppMain>
      </v-dialog>

      <v-row justify="center">
        <v-dialog
          v-model="verifiedAccount"
          persistent
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Cuenta Verificada
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5">
              Cuenta Verificada
            </v-card-title>
            <v-card-text>
              Su cuenta ya está verificada, no es necesario realizar alguna otra acción.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="verifiedAccount = false"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import CardIeaAppMain from "./CardIeaAppMain";
import CardIeaApp from "./CardIeaApp";
import VueFakeInput from "./VueFakeInput";
import InputCustom from "./InputCustom";
import MessagesRules from "../config/MessagesRules";

export default {
  name: "DialogValidationAlumno",
  components: {
    CardIeaAppMain,
    CardIeaApp,
    VueFakeInput,
    InputCustom
  },

  data: () => ({
    dialog: false,
    verifiedAccount: false,
    emailLabel:"",
    smsLabel:"",
    codeSms: "",
    codeEmail: "",
    validateEmail:true,
    validateSms:true,
    panelEmail : false,
    panelSms:false,
    omitir : false,
    cantidadValidacionEmail:0,
    cantidadValidacionSms:0,
    inputs: [
      {
        tag: "email",
        text: "Email",
        placeholder: "ejemplo@ejemplo.com",
        icon: "mdi-email",
        required: true,
        value: "",
        type: "email",
        rules: [
          v => !!v || "Email" + MessagesRules.required,
          v => /.+@.+\..+/.test(v) || MessagesRules.email
        ],
        counter: 0
      },
      {
        tag: "areaCelular",
        text: "N° Area celular",
        placeholder: "####",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "####",
        rules: [v => !!v || "Area" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "telefonoCelular",
        text: "Celular - movil",
        placeholder: "########",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "########",
        rules: [v => !!v || "Telefono" + MessagesRules.required],
        counter: 0
      }
    ]
  }),

  methods: {
    async loadInitial() {
      await this.$API
      .get({
        url: "verificacion/code",
        data: {}
      })
      .then(res => {
        this.validateEmail = res.tipo1
        this.validateSms = res.tipo2

        this.inputs[0].value = res.email
        this.inputs[1].value = res.areaCelular
        this.inputs[2].value = res.telefonoCelular

        this.emailLabel = res.email
        this.smsLabel = res.numeroDeTlf

        if(!res.tipo1 || !res.tipo1){
          this.$store.dispatch("omitirValidacion", false);
        }

        if(res.tipo1 && res.tipo2){
          this.verifiedAccount = true;
        }
      });
    },
    async restCode(type) {
      await this.$API
      .post({
        url: "reset/code",
        data: {
          tipo:type,
          email:this.inputs[0].value,
          areaCelular:this.inputs[1].value,
          telefonoCelular:this.inputs[2].value,
        },
        form:false
      })
      .then(res => {
        if(type == 1){
          this.emailLabel = res
          this.cantidadValidacionEmail++
          this.panelEmail = false
        }else{
          this.smsLabel = res
          this.cantidadValidacionSms++
          this.panelSms = false
        }
      });
    },
    async store (type,value){
      await this.$API
      .post({
        url: "validacion/code",
        data: {
          code:value,
          tipo:type,
          email:this.inputs[0].value,
          areaCelular:this.inputs[1].value,
          telefonoCelular:this.inputs[2].value,
        },
        form:false
      })
      .then(() => {
        if(type == 1){
          this.validateEmail = true
        }else{
          this.validateSms = true
        }
      });
    },
    omitirValidacion(){
      this.$store.dispatch("omitirValidacion", true);
    }
  },

  mounted() {
    this.loadInitial();
  },
 
  computed: {
    loader() {
      return this.$store.getters.loader;
    },
    viewDialog() {
      if(this.$store.getters.omitirValidacion){
        return false;
      }
      if(this.validateEmail && this.validateSms){
        return false;
      }else{
        return true;
      }     
    }
  },
   watch: {
    codeEmail: function(val) {
      if (val.length == 4) {
        this.store(1,val);
      }
      return val;
    },
    codeSms: function(val) {
      if (val.length == 4) {
        this.store(2,val);
      }
      return val;
    }
  },
};
</script>
